import React from 'react';

const sizeMap = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
};

export default function Spinner({
    size = 'md',
    text,
    center = false,
    className = '',
}) {
    const spinner = (
        <svg className={`animate-spin ${sizeMap[size] || sizeMap.md} text-gray-400 ${className}`} fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
    );

    if (center) {
        return (
            <div className="flex flex-col items-center justify-center py-12 gap-3">
                {spinner}
                {text && <p className="text-sm text-gray-500">{text}</p>}
            </div>
        );
    }

    if (text) {
        return (
            <span className="inline-flex items-center gap-2 text-sm text-gray-500">
                {spinner}
                {text}
            </span>
        );
    }

    return spinner;
}
